export const iconFontAwesomeShoppingNfcSymbol = (
	<i className="fa-solid fa-nfc-symbol"></i>
);
